import axios from 'axios'

const processTask = 'process-task'

export default {
  getProcessTaskFullList(context1) {
    const context = context1
    axios.get(`${processTask}/fulllist`).then(response => {
      context.setProcessTask(response.data)
    }, () => {
    })
  },
  getProcessTask(context1) {
    const context = context1
    let params = { query: context.searchQuery, page: context.currentPage - 1 }
    if (params !== {}) {
      params = { params: { query: context.searchQuery, page: context.currentPage - 1 } }
    } else {
      params = { params: {} }
    }
    axios.get(processTask, params).then(response => {
      context.setProcessTask(response.data)
    }, () => {
    })
  },
  addProcessTask(context1, body) {
    const context = context1
    context.$vs.loading()
    axios.post(processTask, body).then(response => {
      context.$vs.loading.close()
      context.processTaskAdded(response.data)
    }, error => {
      context.$vs.loading.close()
      context.processTaskNotAdded(error.response.data.return_message)
    })
  },
  updateProcessTask(context1, id, body) {
    const context = context1
    context.$vs.loading()
    axios.put(`${processTask}/${id}`, body).then(response => {
      context.$vs.loading.close()
      context.processTaskUpdated(response.data)
    }, error => {
      context.$vs.loading.close()
      context.processTaskNotUpdated(error.response.data.return_message)
    })
  },
  delete(context1, id) {
    const context = context1
    context.$vs.loading()
    axios.delete(`${processTask}/${id}`).then(response => {
      context.$vs.loading.close()
      context.processTaskDeleted(response.data.return_message)
    }, error => {
      context.$vs.loading.close()
      context.processTaskNotDeleted(error.response.data.return_message)
    })
  },
  getProcessTaskById(context1, id) {
    const context = context1
    context.$vs.loading()
    axios.get(`${processTask}/${id}`).then(response => {
      context.$vs.loading.close()
      context.setProcessTask(response.data)
    }, error => {
      context.$vs.loading.close()
      context.processTaskNotFound(error.response.data.return_message)
    })
  },
}
